module.exports = __webpack_public_path__ + "img/1.fce3fa6d.png";